<template>
  <div style="min-height:600px; background-color: white">
    <a-breadcrumb style="padding: 16px 24px">
      <a-breadcrumb-item>
        <router-link :to="{name:'scf'}">
          <a-icon type="home"/>
          <span>首页</span>
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item href="">
        <span>{{ memberInfo.name }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <a-page-header
      style="border: 1px solid rgb(235, 237, 240); text-align:center"
    >
      <h3 class="text-title">{{ memberInfo.name }}</h3>
      <a-descriptions size="small" :column="2">
        <a-descriptions-item label="">
          <a-icon type="team"></a-icon>
          {{ memberInfo.pageview }}
        </a-descriptions-item>
        <a-descriptions-item label="">
          <a-icon type="clock-circle"></a-icon>
          2021-7-24
        </a-descriptions-item>

      </a-descriptions>

    </a-page-header>

    <!--    <div  id="course-info" v-html="item.desc"></div>-->
    <div style="padding: 16px 24px">
      <div v-html="memberInfo.desc"></div>

      <a-divider/>

    </div>


  </div>
</template>

<script>
import {domain, getMemberInfo} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";

export default {
  name: "MemberInfo",
  props: {
    id: ''
  },
  data() {
    return {
      memberInfo: ''
    };
  },
  watch: {
    $route(to, from) {
      if ((to.name === from.name) && (to.path !== from.path)) {
        if (to.params.id !== from.params.id){
          this.id = to.params.id
          getMemberInfo(this.id).then(res => {
            this.memberInfo = filterUnderLine(res.data);
            let w = window.screen.width;
            if(w<400){
              this.memberInfo.desc = this.memberInfo.desc.replace(/<img src="\/scf_media/g, '<img width="100%" src="' + `${domain}` + '/scf_media')
            }else{
              this.memberInfo.desc = this.memberInfo.desc.replace(/<img src="\/scf_media/g, '<img src="' + `${domain}` + '/scf_media')
            }

          }).catch(err => {
            console.log(err)
          });
        }
      }

    }
  },
  mounted() {

    getMemberInfo(parseInt(this.id)).then(res => {
      this.memberInfo = filterUnderLine(res.data)
      this.memberInfo.updateTime = this.memberInfo.updateTime.split('T')[0]
      let w = window.screen.width;
      if(w<400){
        this.memberInfo.desc = this.memberInfo.desc.replace(/<img src="\/scf_media/g, '<img width="100%" src="' + `${domain}` + '/scf_media')
      }else{
        this.memberInfo.desc = this.memberInfo.desc.replace(/<img src="\/scf_media/g, '<img src="' + `${domain}` + '/scf_media')
      }
    })


  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/content/MemberInfo.vue